export function isFunction<T>(func: T | null | undefined): func is T {
	return typeof func === 'function';
}
